import { StrictMode } from 'react';

import { createRoot, hydrateRoot } from 'react-dom/client';

// Шрифты локально (Fontsource), а не с Google Fonts — из РФ он грузится нестабильно
import '@fontsource-variable/oswald/index.css';
import '@fontsource-variable/roboto-condensed/index.css';
import '@shared/styles/font-fallbacks.css';

import { stopEarlyClickCapture } from '@app/lib/replayEarlyClick';
import { keepScrollOnHydrate, router, routerReady } from '@app/router';
import { isBackgroundPreloading, preloadPages } from '@app/router/preloadPages';
import { isChunkLoadError, reloadOnce } from '@shared/lib';

import './index.css';
import '@shared/styles/theme-vars.css';
import '@app/styles/global.css';
import { App } from './App'; // Убрали .js, Vite подхватит .tsx

// Vite не смог подгрузить кусочек сборки (страница открыта до деплоя) — перезагружаемся
// Сбой фоновой докачки (preloadPages) пропускаем: его гасит сама докачка, страница не теряет форму
window.addEventListener('vite:preloadError', (event) => {
  if (isBackgroundPreloading()) return;
  if (reloadOnce()) event.preventDefault();
});

const rootElement = document.getElementById('root');

if (rootElement) {
  const application = (
    <StrictMode>
      <App />
    </StrictMode>
  );
  // Код страницы — до гидратации: иначе React приостановил бы её и держал «мёртвый» HTML,
  // а нажатие до загрузки JS повторялось бы в негидратированную кнопку
  await routerReady();
  const failed = Object.values(router.state.errors ?? {});
  // Не загрузился код страницы (вкладка открыта до деплоя) — перезагрузка, а не экран ошибки
  // поверх готового HTML
  const reloading = failed.some(isChunkLoadError) && reloadOnce();
  if (!reloading) {
    stopEarlyClickCapture();
    keepScrollOnHydrate();
    // Ошибка начального маршрута рисуется заново: гидратировать её поверх пререндера нельзя
    if (!failed.length && rootElement.dataset.prerenderPath === window.location.pathname)
      hydrateRoot(rootElement, application);
    else createRoot(rootElement).render(application);
  }
  // После load: фоновая подгрузка не должна конкурировать с картинками и шрифтами текущей страницы
  if (document.readyState === 'complete') preloadPages();
  else window.addEventListener('load', preloadPages, { once: true });
}
